import {
  BarometerInHg,
  BarometerTrend,
  CloudCoverPercent,
  WaypointFilter,
  WindDirection,
  WindMph,
} from '@omniafishing/core';
import { Form, Input, Modal } from 'antd';
import React from 'react';
import { useWaypointFilters } from '../../../../hooks/use_waypoint_filters';
import { WaypointType } from './filters_screen';

interface WaypointFilterNameModalProps {
  onSuccess: (waypointFilter: WaypointFilter) => void;
  onCancel: () => void;
  open: boolean;
  selectedBarometricPressures: BarometerInHg[] | null;
  selectedBarometricPressureTrends: BarometerTrend[] | null;
  selectedCloudCovers: CloudCoverPercent[] | null;
  selectedEndDate: string | null;
  selectedStartDate: string | null;
  selectedWaterbodyIds: string[] | null;
  selectedWaypointTypes: WaypointType[] | null;
  selectedWindDirections: WindDirection[] | null;
  selectedWindSpeeds: WindMph[] | null;
}

export const WaypointFilterNameModal = (props: WaypointFilterNameModalProps) => {
  const {
    onSuccess,
    onCancel,
    open,
    selectedBarometricPressures,
    selectedBarometricPressureTrends,
    selectedCloudCovers,
    selectedEndDate,
    selectedStartDate,
    selectedWaterbodyIds,
    selectedWaypointTypes,
    selectedWindDirections,
    selectedWindSpeeds,
  } = props;
  const [form] = Form.useForm();
  const { createWaypointFilter } = useWaypointFilters();

  const clearForm = () => {
    form.resetFields();
  };

  const submitForm = (values: { name: string }) => {
    createWaypointFilter.mutate(
      {
        name: values.name,
        start_date: selectedStartDate,
        end_date: selectedEndDate,
        waterbodies: selectedWaterbodyIds,
        waypoint_types: selectedWaypointTypes,
        barometer_in_hgs: selectedBarometricPressures,
        barometer_trends: selectedBarometricPressureTrends,
        wind_directions: selectedWindDirections,
        wind_mphs: selectedWindSpeeds,
        cloud_cover_percents: selectedCloudCovers,
      },
      {
        onSuccess: (waypointFilter) => {
          clearForm();
          onSuccess(waypointFilter);
        },
      }
    );
  };

  return (
    <Modal
      onOk={() => {
        form.submit();
      }}
      onCancel={() => {
        clearForm();
        onCancel();
      }}
      open={open}
      title="Save Filter"
      destroyOnClose
    >
      <Form form={form} onFinish={submitForm}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: `Name is required` }]}
        >
          <Input type="text" placeholder={'Custom Filter'} size="large" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
